import { Pipe, PipeTransform } from '@angular/core';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';

import { UTCtoNGB } from '../utils';

@Pipe({
  name: 'toNGBDate',
  standalone: false,
})
export class ToNGBDatePipe implements PipeTransform {
  public transform(date: Date | string | null): NgbDate | null {
    // pipe receives mixed input, should be unified to strings
    if (typeof date === 'string') {
      return UTCtoNGB(date);
    }
    return date
      ? NgbDate.from({
          year: date.getFullYear(),
          month: date.getMonth() + 1,
          day: date.getDate(),
        })
      : null;
  }
}
